import { render, staticRenderFns } from "./CrewDisplay.vue?vue&type=template&id=0d112b42&scoped=true&lang=pug&"
import script from "./CrewDisplay.vue?vue&type=script&lang=js&"
export * from "./CrewDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CrewDisplay.vue?vue&type=style&index=0&id=0d112b42&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d112b42",
  null
  
)

export default component.exports